import { type ErrorStateAction, ErrorStateView } from "@viajero/shared-ui/error-boundary";
import { RouteFallback } from "@/components/layout/RouteFallback";

type State = {
  title: string;
  description: string;
  actions?: ErrorStateAction[];
};

type Props = {
  isLoading: boolean;
  isNotFound: boolean;
  isError: boolean;
  notFound: State;
  error: State;
};

/**
 * connect-query の useQuery 結果 (loading / NotFound / その他エラー) を共通の見た目で表示する。
 * 店舗詳細・商品詳細など、RPC 取得結果をそのまま画面表示する各所で共通利用する
 * (JPTP_CANSEI-1256)。呼び出し側は取得成功時のみ自身の描画に切り替える。
 *
 * NotFound / エラーは ErrorStateView に委譲し、状況に応じた次のアクション (再読み込み /
 * 店舗詳細に戻る) をボタンとして提示する (JPTP_CANSEI-1522)。
 */
export function QueryStateFallback({ isLoading, isNotFound, isError, notFound, error }: Props) {
  if (isLoading) {
    return <RouteFallback />;
  }
  if (isNotFound) {
    return <ErrorStateView severity="warning" {...notFound} />;
  }
  if (isError) {
    return <ErrorStateView severity="error" {...error} />;
  }
  return null;
}
